import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap/dist/js/bootstrap.bundle.min.js"; 
import "react-datepicker/dist/react-datepicker.css"; 
import './assets/fonts/fonts.css'
import './assets/css/style.css'
import './assets/css/responsive.css'

const root = ReactDOM.createRoot(document.getElementById('root'));
const app = <App />;
if (process.env.NODE_ENV === 'development') {
  // Avoid StrictMode double-invocations that can aggravate ResizeObserver timing
  root.render(app);
} else {
  root.render(
    <React.StrictMode>
      {app}
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
